<template>
    <div>
        <modal ref="modal" :size="'modal-medium'">
            <div class="d-flex flex-column gap-6 mt-6">
                <p class="fs-4 fw-600 text-center">{{$trans('storefront::image_editor.saved_drafts')}}</p>

                <div v-if="store.loadedDrafts && store.loadedDrafts.length > 0" class="gap-3 side-nav-padding" style="background: var(--nav-control-bg); display: grid; grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));">
                    <template v-for="draft in store.loadedDrafts">
                        <draft-card :draft="draft" @onDestroy="loadDrafts"></draft-card>
                    </template>
                </div>

                <div v-else-if="store.loading" class="d-flex justify-content-center align-items-center" style="min-height: 160px">
                    <div  class="spinner-border spinner-border-md text-dark" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>

                <div v-else-if="!store.loading" class="w-100 p-2" style="min-height: 160px; background: var(--nav-control-bg);">
                    <p>{{ $trans('storefront::image_editor.no_drafts_saved') }}</p>
                </div>

                <div class="d-flex flex-column flex-sm-row gap-3 gap-sm-4 justify-content-end">
                    <pagination v-if="store.loadedDrafts" @loadPrevPage="loadPrevPage" @loadNextPage="loadNextPage" :page="store.page" :last-page="store.lastPage" :loading="store.loading"></pagination>

                    <button type="button" class="btn btn-secondary btn-medium" :disabled="store.selectedDraft === null" style="min-width: 120px" @click="addDraft">
                        {{$trans('storefront::image_editor.load')}}
                    </button>
                    <button type="button" class="btn btn-primary btn-medium" data-dismiss="modal" style="min-width: 120px">{{$trans('storefront::image_editor.close')}}</button>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import {useDraftStore} from "./store";
import axios from 'axios';
import DraftCard from "./DraftCard";
import Pagination from "../Pagination";

export default {
    components: {Pagination, DraftCard},
    setup() {
        const store = useDraftStore();
        return {store};
    },
    methods: {
        open() {
            this.$refs['modal'].openModal();

            this.loadDrafts();
        },
        loadDrafts() {
            let app = this;
            this.store.loading = true;

            this.store.selectedDraft = null;

            axios.get(`/image-editor/drafts/index?page=${app.store.page}`).then(function (response) {
                app.store.lastPage = response.data.last_page ?? 1;
                app.store.$patch({
                    loadedDrafts: response.data.data ?? null,
                })
            }).catch(function (error) {
                $swal.fire($trans('storefront::image_editor.error'), $trans('storefront::image_editor.error_general'),'error');
                console.log(error);
            }).finally(()=> {
               this.store.loading = false;
            });
        },
        async addDraft() {
            if (this.store.selectedDraft === null) {
                return;
            }

            const draft = this.store.loadedDrafts.find(obj => obj.id === this.store.selectedDraft);
            let data = await this.fetchDataFromUrl(draft.image_editor_data);
            window.imageEditor.load(JSON.parse(data), ()=> {
                this.$refs['modal'].closeModal();
            })
        },
        async fetchDataFromUrl(url) {
            //todo make this dev only
            url = url.replace("http://127.0.0.1:8000", "http://localhost:3000");

            try {
                const response = await fetch(url);
                return await response.text();
            } catch (error) {
                console.error("Error loading data:", error);
            }
        },
        loadNextPage() {
            this.store.page++;
            this.loadDrafts();
        },
        loadPrevPage() {
            this.store.page--;
            this.loadDrafts();
        },
    }
}
</script>
